import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  desktops: [],
  desktopFilter: null,
  selectedDesktop: null
};

const desktopSlice = createSlice({
  name: "desktops",
  initialState,
  reducers: {    
    setDesktops: (state, action) => {
        state.desktops = action.payload
    },
    setDesktopFilter: (state, action) => {
        state.desktopFilter = action.payload.desktopFilter;
    },
    setSelectedDesktop: (state, action) => {
        state.selectedDesktop = action.payload.selectedDesktop;
    },
    clearDesktops: () => initialState
  },
});

export const { setDesktopFilter, setSelectedDesktop, setDesktops, clearDesktops } = desktopSlice.actions;
export default desktopSlice.reducer;
